<section class="login-2">
  <div class="container">
    <div class="row login-box">


<div class="col-lg-6 col-md-12 bg-img ">
  <div class="info">
    <div class="info-text">
        <p class="welcome-text">Welcome to</p>
        <p class="zyno-tilte">ZYNO Procurement</p>

        
      </div>
  </div>
</div>
      <div class="col-lg-6 col-md-12">
        <div class="login-background form-info">
          <div class="card-body text-black">
            <img src="../../assets/images/image (3).png" class="img-fluid" />
            <p class="small">Enter <span class="title_vendor-login">Employee login</span> credentials below to proceed.</p>

            <form name="loginForm" (ngSubmit)="loginForm.valid" #loginForm="ngForm" novalidate>
              <!-- Username -->
              <label class="control-label">User Name</label>
              <div class="form-group login-formgroup-v input-container">
                <i class="fa fa-user icon"></i>
                <input type="text" class="form-control" name="user_name" id="user_name"
                  [(ngModel)]="login.user_name" (ngModelChange)="login.user_name = login.user_name?.trim()"
                  #user_name="ngModel" required
                  [ngClass]="{ 'is-invalid': loginForm.submitted && user_name.errors }">
                <div *ngIf="loginForm.submitted && user_name.errors" class="invalid-feedback">
                  <div *ngIf="user_name.errors['required']">Employee code is required</div>
                </div>
              </div>

              <!-- Password -->
              <label class="control-label">Password</label>
              <div class="form-group input-container" style="position: relative;">
                <i class="fa fa-key icon"></i>
                <input [type]="show_button ? 'text' : 'password'" class="form-control" name="password" id="password"
                  [(ngModel)]="login.password" #password="ngModel" required
                  [ngClass]="{ 'is-invalid': loginForm.submitted && password.errors }">
                <span
                  style="position: absolute; right: 5px; top: 50%; transform: translateY(-50%); cursor: pointer; color: rgb(153, 132, 97); font-size: 18px;"
                  title="View Password">
                  <i [ngClass]="show_button ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'"
                    (click)="showPassword()"></i>
                </span>
                <div *ngIf="loginForm.submitted && password.errors" class="invalid-feedback">
                  <div *ngIf="password.errors['required']">Password is required</div>
                </div>
              </div>

              <!-- Forgot Password -->
              <p class="forgotPassword" (click)="forgotPassword()">Forgot password</p>

              <!-- Buttons -->
              <div class="loginVendorButton">
                <button type="button" class="newloginbtn" (click)="loginUser()">Login</button>
                <div class="text-center">or</div>
                <button type="button" class="newloginbtn" (click)="loginVendor()">Vendor Login</button>

              </div>
            </form>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>










<!-- 
<section class="vh-100 backs-image d-flex justify-content-center align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-10 col-lg-6">
        <div class="login-background card shadow-lg">
          <div class="card-body text-black">
            <img src="../../assets/logo/image (2).png" class="img-fluid" />

            <form name="loginForm" (ngSubmit)="loginForm.valid" #loginForm="ngForm" novalidate>
      
              <label class="control-label">User Name</label>
              <div class="form-group login-formgroup-v input-container" style="margin-top: 5px;">
                <i class="fa fa-user icon"></i>
                <input type="text" class="form-control" name="user_name" id="user_name"
                  [(ngModel)]="login.user_name" (ngModelChange)="login.user_name = login.user_name?.trim()"
                  #user_name="ngModel" required
                  [ngClass]="{ 'is-invalid': loginForm.submitted && user_name.errors }">
                <div *ngIf="loginForm.submitted && user_name.errors" class="invalid-feedback">
                  <div *ngIf="user_name.errors['required']">Employee code is required</div>
                </div>
              </div>


              <label class="control-label">Password</label>
              <div class="form-group input-container" style="position: relative; margin-top: 5px;">
                <i class="fa fa-key icon"></i>
                <input [type]="show_button ? 'text' : 'password'" class="form-control" name="password" id="password"
                  [(ngModel)]="login.password" #password="ngModel" required
                  [ngClass]="{ 'is-invalid': loginForm.submitted && password.errors }">
                <span
                  style="position: absolute; right: 5px; top: 50%; transform: translateY(-50%); cursor: pointer; color: rgb(153, 132, 97); font-size: 18px;"
                  title="View Password">
                  <i [ngClass]="show_button ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'"
                    (click)="showPassword()"></i>
                </span>
                <div *ngIf="loginForm.submitted && password.errors" class="invalid-feedback">
                  <div *ngIf="password.errors['required']">Password is required</div>
                </div>
              </div>

           
              <span style="cursor: pointer; color: blue;" (click)="forgotPassword()">Forgot password</span>

              
              <div class="loginVendorButton">
                <button type="button" class="btn btn-primary newloginbtn btn-block" (click)="loginUser()">Login</button>
                <div class="text-center">or</div>
                <button type="button" class="btn btn-primary newloginbtn btn-block" (click)="loginVendor()">Vendor Login</button>

              </div>
            </form>

          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->
